import {elements, screenSizes} from "./config";
import "jquery.scrollto";

let mainMenuHeight      = elements.mainNavigation.height(),
    subMenuHeight       = elements.secondaryNavigation.height(),
    fixHeadHeight        = elements.fixedHeaderContent.height();

let scrolling = false,
    previousTop = 0,
    currentTop = 0,
    scrollDelta = 10,
    scrollOffset = 150;

function checkSimpleNavigation(currentTop)
{
  //there's no secondary nav or secondary nav is below primary nav
    if (previousTop - currentTop > scrollDelta) {
      //if scrolling up...
        elements.mainNavigation.removeClass('is-hidden');
    } else if ( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
      //if scrolling down...
        elements.mainNavigation.addClass('is-hidden');
    }
}

function checkStickyNavigation(currentTop)
{
  //secondary nav below intro section - sticky secondary nav
    let secondaryNavOffsetTop = elements.belowNavHeroContent.offset().top - subMenuHeight - mainMenuHeight + 50;

    if (previousTop >= currentTop ) {
      //if scrolling up...
        if ( currentTop < secondaryNavOffsetTop ) {
          //secondary nav is not fixed
            elements.mainNavigation.removeClass('is-hidden');
            elements.secondaryNavigation.removeClass('fixed slide-up');
            elements.belowNavHeroContent.removeClass('secondary-nav-fixed');
        } else if ( previousTop - currentTop > scrollDelta ) {
          //secondary nav is fixed
            elements.mainNavigation.removeClass('is-hidden');
            elements.secondaryNavigation.removeClass('slide-up').addClass('fixed');
            elements.belowNavHeroContent.addClass('secondary-nav-fixed');
        }
    } else {
      //if scrolling down...
        if ( currentTop > secondaryNavOffsetTop + scrollOffset ) {
          //hide primary nav
            elements.mainNavigation.addClass('is-hidden');
            elements.secondaryNavigation.addClass('fixed slide-up');
            elements.belowNavHeroContent.addClass('secondary-nav-fixed');
        } else if ( currentTop > secondaryNavOffsetTop ) {
          //once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset
            elements.mainNavigation.removeClass('is-hidden');
            elements.secondaryNavigation.addClass('fixed').removeClass('slide-up');
            elements.belowNavHeroContent.addClass('secondary-nav-fixed');
        }
    }
}

function autoHideHeader()
{
    currentTop = $(window).scrollTop();

    ( elements.belowNavHeroContent.length > 0 ) ? checkStickyNavigation(currentTop) : checkSimpleNavigation(currentTop); // jshint ignore:line

    previousTop = currentTop;
    scrolling = false;
}

function checkWindowWidth()
{
  //check window width (scrollbar included)
    let e = window,
    a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return e[a + 'Width'] >= screenSizes.large;
}


export const nav = {
    isInitialized: false,

    primaryNav: $('.n7w-primary-nav'),
    searchOverlay: $('.n7w-overlay'),
    searchTrigger: $('.n7w-search-trigger'),
    navTrigger: $('.n7w-nav-trigger'),
    mainContent: $('.n7w-main-content'),
    mainHeader: $('.n7w-main-header'),

  /**
   * Init navs if required
   */
    init: function () {
        if ( !nav.isInitialized ) {
            // Init
            nav.transparency();
            nav.onScroll();
            nav.moveMenu();
            nav.submenuScrollspy();

          //prevent default clicking on direct children of .n7w-primary-nav
            nav.primaryNav.children('.menu-item-has-children').children('a').on('click', function (event) {
                event.preventDefault();
            });

            nav.navTrigger.on('click', function (event) {
                nav.toggleNav(event);
            });

            nav.searchTrigger.on('click', function (event) {
                nav.openSearch(event);
            });

            $('.menu-item-has-children').children('a').on('click', function (event) {
                nav.openSubmenu($(this), event);
            });

          //submenu items - go back link
            $('.go-back').on('click', function () {
                $(this).parent('ul').addClass('is-hidden').parent('.menu-item-has-children').parent('ul').removeClass('moves-out');
            });

            $('.open-panel').on('click', function (event) {
                nav.openPanel(event);
            });

            $('.n7w-panel').on('click', function (event) {
                if ( $(event.target).is('.n7w-panel') || $(event.target).is('.n7w-panel-close') ) {
                    nav.closePanel();
                    event.preventDefault();
                }
            });

            nav.searchOverlay.on('click', function () {
                nav.closeNav();
                nav.toggleSearch('close');
                nav.searchOverlay.removeClass('is-visible');
            });

            // Change sizes if resize
            $(window).on('resize', function () {
                mainMenuHeight = elements.mainNavigation.height();
                subMenuHeight = elements.secondaryNavigation.height();

                (!window.requestAnimationFrame) ? setTimeout(nav.moveMenu, 300) : window.requestAnimationFrame(nav.moveMenu);
            });

            // Contact Button & Form
            setTimeout(nav.contactButton, 3000);

            // Set new state, init only once
            nav.isInitialized = true;
        }
    },

  /**
   * Desktop: Open Submenu
   */
    openSubmenu: function (selected, event) {
        if ( !checkWindowWidth() ) {
            event.preventDefault();
        }

        if ( selected.next('ul').hasClass('is-hidden') ) {
            //desktop version only
            selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.menu-item-has-children').parent('ul').addClass('moves-out');
            selected.parent('.menu-item-has-children').siblings('.menu-item-has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
            nav.searchOverlay.addClass('is-visible');
        } else {
            selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.menu-item-has-children').parent('ul').removeClass('moves-out');
            nav.searchOverlay.removeClass('is-visible');
        }

        nav.toggleSearch('close');
    },

  /**
   * Mobile open & close
   */
    toggleNav: function (event) {
        event.preventDefault();
        if ( nav.mainContent.hasClass('nav-is-visible') ) {
            nav.closeNav();
            nav.searchOverlay.removeClass('is-visible');
        } else {
            $(this).addClass('nav-is-visible');
            nav.primaryNav.addClass('nav-is-visible');
            nav.mainHeader.addClass('nav-is-visible');
            nav.mainContent.addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('body').addClass('overflow-hidden');
            });
            nav.toggleSearch('close');
            nav.searchOverlay.addClass('is-visible');
        }
    },

  /**
   * Close Nav
   */
    closeNav: function () {
        nav.navTrigger.removeClass('nav-is-visible');
        nav.mainHeader.removeClass('nav-is-visible');
        nav.primaryNav.removeClass('nav-is-visible');
        $('.menu-item-has-children ul').addClass('is-hidden');
        $('.menu-item-has-children a').removeClass('selected');
        $('.moves-out').removeClass('moves-out');
        nav.mainContent.removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
            $('body').removeClass('overflow-hidden');
        });
    },

  /**
   * Toggle Search Field
   * @param type
   */
    toggleSearch: function (type) {
        const $searchClass = $('.n7w-search');

        if (type === "close") {
          //close search
            $searchClass.removeClass('is-visible');
            nav.searchTrigger.removeClass('search-is-visible');
            nav.searchOverlay.removeClass('search-is-visible');
            $('html').removeClass('noscroll');
            $('body').unbind('touchmove');
        } else {
          //toggle search visibility
            $searchClass.toggleClass('is-visible');
            nav.searchTrigger.toggleClass('search-is-visible');
            nav.searchOverlay.toggleClass('search-is-visible');
            if (nav.mainHeader.hasClass('transparent-bg')) {
                nav.mainHeader.removeClass('transparent-bg'); }
            if ($(window).width() > screenSizes.large && $searchClass.hasClass('is-visible')) {
                $searchClass.find('input[type="search"]').focus(); }
            ($searchClass.hasClass('is-visible')) ? nav.searchOverlay.addClass('is-visible') : nav.searchOverlay.removeClass('is-visible');
            $('html').addClass('noscroll');
            $('body').bind('touchmove', function (e) {
                e.preventDefault();
            });
        }
    },

    openSearch: function () {
        event.preventDefault();

        if ($(this).hasClass('search-is-visible')) {
            nav.toggleSearch('close');
            nav.searchOverlay.removeClass('is-visible');
        } else {
            nav.toggleSearch();
        }

        nav.closeNav();
    },

  /**
   * Open Panel
   */
    openPanel: function () {
        event.preventDefault();

        nav.panel = $('.n7w-panel');
        let targetForm = $(this).attr('data-target');

        nav.panel.addClass('is-visible');
        $('.n7w-overlay').css('z-index', '3').addClass('panel-is-visible').addClass('is-visible');

        if (targetForm) {
            nav.panel.find('.nav-tabs a[href="#' + targetForm + '"]').tab('show');
        }

        $('html').addClass('noscroll');
    },

  /**
   * Close Panel
   */
    closePanel: function () {
        $('.n7w-panel').removeClass('is-visible');
        $('.n7w-overlay').delay(800).removeClass('is-visible').removeClass('panel-is-visible').css('z-index', '2');
        $('html').removeClass('noscroll');
    },

  /**
   * On Scroll behavior
   */
    onScroll: function () {
        $(window).on('scroll', function () {
            if ( !scrolling ) {
                scrolling = true;
                (!window.requestAnimationFrame) ? setTimeout(autoHideHeader, 250) : requestAnimationFrame(autoHideHeader); // jshint ignore:line
            }
            nav.transparency();
        });
    },

  /**
   * Set Menu Transparency
   */
    transparency: function () {
        if ($(window).scrollTop() ) { //abuse 0 == false :)
            elements.mainNavigation.removeClass('transparent-bg');
        } else {
            if ( (!$("body").hasClass("fee") && !$("body").hasClass("new7wonders-n7w") && $('.image-header').length) && ($(window).width() < screenSizes.large)) {
                elements.mainNavigation.addClass('transparent-bg');
                $('.wrap.container').removeClass('wrap');
                $('.wrap.container-fluid').removeClass('wrap');
            } else {
              // $('.n7w-main-content').css('margin-top', mainMenuHeight + subMenuHeight);
            }
        }
    },

  /**
   * Move menu based on screen width
   */
    moveMenu: function () {
        const navigation = $('.n7w-nav');
        let desktop = checkWindowWidth();
        if ( desktop ) {
            navigation.detach();
            navigation.insertBefore('.n7w-header-buttons');
        } else {
            navigation.detach();
            navigation.insertAfter('.n7w-main-content');
        }
    },

  /**
   * Animate Contact Button
   */
    contactButton: function () {
        $("[data-words]").attr("data-words", function (i, d) {
            let $self = $(this),
            $words = d.split("|"),
            tot = $words.length,
            c = 0;

          // CREATE SPANS INSIDE SPAN
            for (var f = 0; f < tot; f++) {
                $self.append(
                    $(
                        '<span/>',
                        {text: $words[f]}
                    )
                );
            }

          // COLLECT WORDS AND HIDE
            $words = $self.find("span").hide();

            $self.parent().css('right', '-5px');

          // ANIMATE AND LOOP
            (function loop()
            {
                $self.animate({width: $words.eq(c).width()});
                $words.stop().fadeOut().eq(c).fadeIn().delay(3000).show(0, loop);
                c = ++c % tot;
            }());

        });
    },

  /**
   * Scrollspy and smooth scrolling for subnav
   * todo: This needs a cleanup and does not exactly do what it should
   */
    submenuScrollspy: function () {
        $('body').scrollspy({target: ".n7w-sub-nav", offset: subMenuHeight + fixHeadHeight + 25 });


        // Function to aware of changing classes
        (function () {
          // Your base, I'm in it!
            let originalAddClassMethod = jQuery.fn.addClass;

            jQuery.fn.addClass = function () {
              // Execute the original method.
                let result = originalAddClassMethod.apply(this, arguments);

              // trigger a custom event
                jQuery(this).trigger('cssClassChanged');

              // return the original result
                return result;
            };
        })();


        function subnavActiveItem()
        {
            if (elements.secondaryNavigation.length) {
              //grab the current item, to be used in resize function
                const scrollTo = elements.secondaryNavigation.find('ul li.active');
              //scroll it to the destination
                elements.secondaryNavigation.find('ul').scrollTo(scrollTo, 800, {
                    interrupt: true,
                });
              //cancel the link default behavior
                return false;
            }
        }


        $(elements.secondaryNavigation).find("ul li").bind('cssClassChanged', function () {
            subnavActiveItem();
        });


        // Assign the HTML, Body as a variable...
        const $viewport = $('html, body');

        // Add smooth scrolling on all links inside the navbar
        $(elements.secondaryNavigation).find("a").on('click', function (event) {
          // Make sure this.hash has a value before overriding default behavior

            if (this.hash !== "") {
              // Prevent default anchor click behavior
                event.preventDefault();

              // Store hash
                let hash = this.hash;

              // Using jQuery's animate() method to add smooth page scroll
              // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area

                $viewport.animate({
                    scrollTop: $(hash).offset().top  - subMenuHeight - fixHeadHeight,
                }, 800, function () {

                  // Stop animation on user interaction
                    $viewport.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");

                  // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;

                });
            }  // End if
        });

        // If anchor exists in URL scroll to the element
        $(window).load(function () {
          // Remove the # from the hash, as different browsers may or may not include it
            let hash = location.hash.replace('#','');

            if (hash !== '') {
                if (elements.secondaryNavigation.length) {
                    $('html, body').delay(100).animate({
                        scrollTop: $('#' + hash).offset().top - subMenuHeight - fixHeadHeight,
                    }, 800);
                }
            }
        });
    },
};
